import { $closest, $delegate, $el, $remove, $removeClass } from 'fxdom/es';
import { go } from 'fxjs/es';
import { MShopUtilTmplS } from '../../S/Tmpl/module/MShopUtilTmplS.js';
import { ToastConfig } from './toast.config.ts';

/**
 * @param message_el {HTMLElement}
 * @param toast_container_el {HTMLElement?}
 */
const removeToastMessage = (message_el, toast_container_el) => {
  $remove(message_el);
  $removeClass(ToastConfig.endClass, message_el);
  if (toast_container_el && !toast_container_el.children.length) {
    $remove(toast_container_el);
  }
};

/**
 * @param opt
 * @param toast_container_el {HTMLElement?}
 */
export const initToastContainer = (opt, toast_container_el) => {
  return go(
    $el(MShopUtilTmplS.createToastContainer(opt)),
    $delegate('animationend', '.toast-message', (e) => {
      if (e.animationName !== 'toastOut') return;
      removeToastMessage(e.currentTarget, toast_container_el);
    }),
    $delegate('click', '.toast-message__close', (e) => {
      removeToastMessage($closest('.toast-message', e.target), toast_container_el);
    }),
  );
};
